import React, { useState } from "react";
import { Tabs } from "antd";
import AnimalPhotos from "./AnimalPhotos";
import PedigreeCertificate from "./PedigreeCertificate";
import AnimalTransfers from "./AnimalTransfers";

const AnimalInventoryTab = ({ recordId }) => {

  const items = [
    { key: "photos", label: "Photos", children: <AnimalPhotos recordId={recordId}/> },
    // { key: "certificate", label: "Certificate", children: <PedigreeCertificate/> },
    { key: "transfer", label: "Transfer History", children: <AnimalTransfers recordId={recordId}/> },
  ];

  return <Tabs type="card" items={items} />;
};

export default AnimalInventoryTab;
